import { COLOR_TEXT_PRIMARY_INVERSE } from '@alltrails/denali/tokens';
import { useId } from 'react';

type FacebookIconProps = {
  className?: string;
  openInNewTab?: boolean;
  color?: string;
  noFollowSocials?: boolean;
};

export default function FacebookIcon({
  className = '',
  openInNewTab = false,
  color = COLOR_TEXT_PRIMARY_INVERSE,
  noFollowSocials
}: FacebookIconProps) {
  const titleId = useId();
  return (
    <a
      href="https://www.facebook.com/AllTrails"
      target={openInNewTab ? '_blank' : '_self'}
      className={className}
      data-testid="facebook-icon"
      rel={`noreferrer${noFollowSocials ? ' nofollow' : ''}`}
    >
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <title id={titleId}>Facebook</title>
        <g fill="none" fillRule="evenodd">
          <g fill={color} fillRule="nonzero">
            <g>
              <g>
                <path
                  d="M70.5 2.583c7.122 0 12.917 5.795 12.917 12.917S77.622 28.417 70.5 28.417 57.583 22.622 57.583 15.5 63.378 2.583 70.5 2.583zM70.5 0C61.94 0 55 6.94 55 15.5 55 24.06 61.94 31 70.5 31 79.06 31 86 24.06 86 15.5 86 6.94 79.06 0 70.5 0zm-2.583 12.917h-2.584V15.5h2.584v7.75h3.875V15.5h2.35l.233-2.583h-2.583V11.84c0-.618.124-.862.72-.862h1.863V7.75H71.27c-2.323 0-3.353 1.023-3.353 2.981v2.186z"
                  transform="translate(-71 -590) translate(16 561) translate(0 29)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
}
